<template>
  <div class="box">
    <div class="overhead">
      <div class="nav">
        <div class="nav-item" :class="{active:nav === 0}" @click="navTab('setPhone')">
          <span>修改手机号</span>
          <i class="iconfont iconxiangyou"></i>
        </div>
        <div class="nav-item" :class="{active:nav === 1}" @click="navTab('setPass')">
          <span>修改密码</span>
          <i class="iconfont iconxiangyou"></i>
        </div>
        <div class="nav-item" :class="{active:nav === 2}" @click="navTab('setWx')">
          <span>绑定微信</span>
          <i class="iconfont iconxiangyou"></i>
        </div>
        <div class="nav-item" :class="{active:nav === 3}" @click="navTab('setPay')">
          <span>提现管理</span>
          <i class="iconfont iconxiangyou"></i>
        </div>
      </div>
      <div class="list">
        <router-view @setNav="setNav"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "userAccount",
    data() {
      return {
        nav: 0,
      }
    },
    created() {
      this.$emit('setType', 7)
    },
    methods: {
      // 切换
      navTab(router) {
        this.$router.replace(router)
      },
      setNav(num){
        this.nav = num
      },
    }
  }
</script>

<style scoped lang="scss">
  .box {
    padding: 20px 0;

    .overhead {
      display: flex;
      overflow: hidden;
      height: 482px;
      background: #fff;
      margin-bottom: 28px;

      .nav {
        width: 305px;
        height: 482px;
        padding: 17px 0;

        .nav-item {
          display: flex;
          justify-content: space-between;
          height: 60px;
          font-size: 16px;

          span {
            display: block;
            line-height: 60px;
            margin: 0 24px;
          }

          i {
            display: block;
            line-height: 60px;
            margin-right: 42px;
            font-size: 16px;
          }
        }

        .nav-item.active {
          border: solid 1px #a8dff7;
          border-right: 0;
          position: relative;

          span {
            font-weight: 500;
            color: #00a2ea;
          }

          i {
            display: none;
          }

          &:after {
            position: absolute;
            top: 0;
            right: -1px;
            content: '';
            width: 1px;
            height: 59px;
            background: #fff;
          }
        }
      }

      .list {
        width: 895px;
        height: 482px;
        padding: 17px;
        border: solid 1px #a8dff7;
      }
    }
  }

</style>